
import { Vue, Component, Prop } from "vue-property-decorator"; 
import { Project, User } from "@/generated/graphql"; 
import ProjectRowCard from "@/components/projects/ProjectRowCard.vue";
import ProjectModal from "@/components/companyProjects/ProjectModal.vue";

@Component({
    components: {
        ProjectRowCard,
        ProjectModal
    },
  })
export default class ProjectsInProgressCard extends Vue {
    @Prop({ type: Array }) readonly projects!: Project[];
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: String, required: true }) readonly companyId!: string;

    modalShown: boolean = false;
    selectedProject: Project | undefined = undefined;

    viewProjects(project: Project): void {
        this.modalShown = true;
        this.selectedProject = project; 
    }
    editProjects(project: Project): void {
        this.modalShown = true;
        this.selectedProject = project; 
    }
    get myProjects(): Project[] {
    if (this.projects !== undefined) {
      return this.projects;
    }
    return [];
  }
    hideModal(): void {
      this.modalShown =false;
    }
}
